import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

function BulkPasswordChange() {
  const classes = useStyles();

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("");
  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCource, setSelectedCource] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/filter/all`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      setCenter(response.data.centers);
    } catch (error) {
      console.error("Error fetching center data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue ? newValue.id : event?.target?.value || "");
  };

  const fetchCources = async (selectedCenter) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centerid/${selectedCenter}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      setCources(response.data.center.courses);
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCources(selectedCenter);
  }, [selectedCenter]);

  const handleCourceChange = (event, newValue) => {
    setSelectedCource(newValue ? newValue.id : event?.target?.value || "");
  };
  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
     
      if (selectedCenter && selectedCource) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course`,
          {
            center: {
              centerId: selectedCenter,
              courseId: selectedCource,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );
        setBatches(response.data.center.batches);
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
      fetchBatches();
  }, [selectedCenter, selectedCource]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue ? newValue.id : event?.target?.value || ""); 
  };

  const handleFormSubmit = () => {
    if (!selectedCenter) {
      toast.warn("Please select a center.");
      return;
    }

    if (!selectedCource) {
      toast.warn("Please select a course.");
      return;
    }

    if (!password) {
      toast.warn("Please enter password.");
      return;
    }

    const data = {
      user: {
        center_id: selectedCenter,
        course_id: selectedCource,
        batch_id: selectedBatch,
        password: password,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/password/client/change`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);
        toast.success(`Password Updated Successfully`);
      })
      .catch((error) => {
        toast.error(`Failed to update Password`);
      });
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Change Password
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                {/* <Select
                  labelId="category-label"
                  id="state_id"
                  value={selectedCenter}
                  onChange={handleCenterChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    Select Branch Code
                  </MenuItem>
                  {center &&
                    center.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                      {st.center_code} - {st.center_name}
                      </MenuItem>
                    ))}
                </Select> */}

                <Autocomplete
                  id="center-autocomplete"
                  options={center || []}
                  getOptionLabel={(option) =>
                    option?.center_code
                      ? `${option?.center_code} - ${option?.center_name}`
                      : option?.center_name || ""
                  }
                  getOptionSelected={(option, value) =>
                    option?.id === value?.id
                  }
                  value={
                    center?.find((st) => st.id === selectedCenter) || null
                  }
                  onChange={handleCenterChange}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Branch Code"
                      variant="outlined"
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                {/* <Select
                  labelId="category-label"
                  id="state"
                  value={selectedCource}
                  onChange={handleCourceChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {cources &&
                    cources.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.course_name}
                      </MenuItem>
                    ))}
                </Select> */}

                <Autocomplete
                  id="course-autocomplete"
                  options={cources || []}
                  getOptionLabel={(option) => option?.course_name || ""}
                  getOptionSelected={(option, value) =>
                    option?.id === value?.id
                  }
                  value={
                    cources?.find((st) => st.id === selectedCource) || null
                  }
                  onChange={handleCourceChange}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Course"
                      variant="outlined"
                    />
                  )}
                />
              </div>

            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch
                </FormLabel>
                {/* <Select
                  labelId="category-label"
                  id="batch"
                  value={selectedBatch}
                  onChange={handleBatchChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {batches &&
                    batches.map((batch) => (
                      <MenuItem key={batch.id} value={batch.id}>
                        {batch.batch_name}
                      </MenuItem>
                    ))}
                </Select> */}

                <Autocomplete
                  id="batch-autocomplete"
                  options={batches || []}
                  getOptionLabel={(option) => option?.batch_name || ""}
                  getOptionSelected={(option, value) =>
                    option?.id === value?.id
                  }
                  value={
                    batches?.find((batch) => batch.id === selectedBatch) || null
                  }
                  onChange={handleBatchChange}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Batch"
                      variant="outlined"
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Password <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  placeholder="********"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleToggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
        
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleFormSubmit}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default BulkPasswordChange;
